module.exports = __webpack_public_path__ + "img/avatar_li_lt.57a2c92d.png";